module.exports = __webpack_public_path__ + "img/1GitHub.4b6feba0.svg";